module.exports = __webpack_public_path__ + "img/shape-5@2x.17387162.png";